// extracted by mini-css-extract-plugin
export default {"advertisementBannerDiv":"adv_advertisementBannerDiv__OfONS","advBannerLessPadding":"adv_advBannerLessPadding__5f2wh"};